require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-belle-magazine-hornsby-residence.json") })
        }
      }, "path---journal-belle-magazine-hornsby-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-belle-magazine-hornsby-residence!./.cache/json/journal-belle-magazine-hornsby-residence.json
// module id = 459
// module chunks = 231608221292675